import { ActionTree } from 'vuex'

import { ReceiptState, RootState } from '@/types/store'
import { IReceipt, ReceiptType } from '@/types/receipt'

import {
  getReceipts,
  getReceipt,
  updateReceipt,
  getSummaries,
  getSnapShot,
} from '@/api/receipts'

export const actions: ActionTree<ReceiptState, RootState> = {
  async resetReceipts({ commit }): Promise<void> {
    commit('receiptsLoaded', [])
  },
  async getUncheckedReceipts({ commit }, query?: any): Promise<void> {
    commit('receiptsLoaded', [])
    commit('receiptsLoadStart', true)
    const receipts = await getReceipts('unchecked', 0, query)
    commit('receiptsLoaded', receipts)
  },
  async getLinkerCheckedReceipts({ commit }, query?: any): Promise<void> {
    commit('receiptsLoaded', [])
    commit('receiptsLoadStart', true)
    const receipts = await getReceipts('linkerChecked', 0, query)
    commit('receiptsLoaded', receipts)
  },
  async getLeaderCheckedReceipts({ commit }, query?: any): Promise<void> {
    commit('receiptsLoaded', [])
    commit('receiptsLoadStart', true)
    const receipts = await getReceipts('leaderChecked', 0, query)
    commit('receiptsLoaded', receipts)
  },
  async getUncheckedSystemNgReceipts({ commit }, query?: any): Promise<void> {
    commit('receiptsLoaded', [])
    commit('receiptsLoadStart', true)
    const receipts = await getReceipts('uncheckedSystemNg', 0, query)
    commit('receiptsLoaded', receipts)
  },
  async getSystemNgReceipts({ commit }, query?: any): Promise<void> {
    commit('receiptsLoaded', [])
    commit('receiptsLoadStart', true)
    const receipts = await getReceipts('systemNg', 0, query)
    commit('receiptsLoaded', receipts)
  },
  async getSystemOkReceipts({ commit }, query?: any): Promise<void> {
    commit('receiptsLoaded', [])
    commit('receiptsLoadStart', true)
    const receipts = await getReceipts('systemOk', 0, query)
    commit('receiptsLoaded', receipts)
  },
  async getLinkerNgReceipts({ commit }, query?: any): Promise<void> {
    commit('receiptsLoaded', [])
    commit('receiptsLoadStart', true)
    const receipts = await getReceipts('linkerNg', 0, query)
    commit('receiptsLoaded', receipts)
  },
  async getLeaderNgReceipts({ commit }, query?: any): Promise<void> {
    commit('receiptsLoaded', [])
    commit('receiptsLoadStart', true)
    const receipts = await getReceipts('leaderNg', 0, query)
    commit('receiptsLoaded', receipts)
  },
  async getShopUncheckedReceipts({ commit }): Promise<void> {
    commit('receiptsLoaded', [])
    commit('receiptsLoadStart', true)
    const receipts = await getReceipts('shopUnchecked')
    commit('receiptsLoaded', receipts)
  },
  async getReceipt({ commit }, id: number): Promise<IReceipt> {
    const receipt = await getReceipt(id)
    commit('setReceipt', receipt)
    return receipt
  },
  async getReceiptWithReProcess({ commit }, id: number): Promise<IReceipt> {
    const receipt = await getReceipt(id, { needReProcess: true })
    commit('setReceipt', receipt)
    return receipt
  },
  setReceipt({ commit }, receipt: IReceipt): void {
    commit('setReceipt', receipt)
  },
  setReceipts({ commit }, receipts: IReceipt[]): void {
    commit('receiptsLoaded', receipts)
  },
  setReceiptById({ commit }, id: number): void {
    commit('setReceiptById', id)
  },
  setMasterSearch({ commit }, item: ReceiptState['masterSearchItem']): void {
    commit('setMasterSearch', item)
  },
  updateMasterItem({ commit }, item: ReceiptState['masterSearchItem']): void {
    commit('updateMasterItem', item)
  },
  async updateReceipt({ commit }, receipt: IReceipt): Promise<string> {
    // return error
    try {
      receipt = await updateReceipt(receipt)
      commit('updateReceipt', receipt)
      return ''
    } catch (error) {
      return (error as Error).message
    }
  },
  async getSnapShot({ commit }): Promise<void> {
    const summaries = await getSnapShot()
    commit('summariesLoaded', summaries)
  },
  async getSummaries({ commit }, date: number): Promise<void> {
    commit('setIsSummariesLoading', true)
    const summaries = await getSummaries(date)
    commit('setIsSummariesLoading', false)
    commit('summariesLoaded', summaries)
  },
  setReceiptType({ commit }, receiptType: ReceiptType): void {
    commit('setReceiptType', receiptType)
  },
}
